import Image from "next/image";
import Link from "next/link";
import ProjectCardBottomContributors from "~/components/projectCards/ProjectCardBottomContributors";
import ProjectCardBottomSimple from "~/components/projectCards/ProjectCardBottomSimple";
import CompanyNameLogo from "~/components/elements/CompanyNameLogo";
import { PiImageThin } from "react-icons/pi";

export interface ProjectItemProps {
  project: any;
  isEmbedded?: boolean;
  theme?: string;
  refPageSlug?: string;
  refPageType: string;
  refPageLabel: string;
  projectCardLocation?: string;
}

function ProjectItem({
  project,
  isEmbedded,
  theme,
  refPageSlug,
  refPageType,
  refPageLabel,
  projectCardLocation,
}: ProjectItemProps) {
  function getCompany() {
    return project.companies && project.companies.length > 0
      ? project.companies[0]
      : null;
  }
  const company = getCompany();

  const placeholdersHidden =
    project.thumbnail ||
    company?.name ||
    project.description ||
    project.start_date ||
    project.completed ||
    project.type
      ? true
      : false;

  const cardStyle =
    projectCardLocation === "user_profile" ? "simple" : "contributors";

  const companyComponentVisible =
    company?.name || placeholdersHidden === false ? true : false;

  return (
    <div>
      <Link
        href={`/p/${
          project.id
        }?refPageType=${refPageType}&refPageLabel=${refPageLabel}${
          refPageType === "explore" ? "" : `&refPageSlug=${refPageSlug}`
        }`}
        key={project.id}
        target={isEmbedded ? "_blank" : "_self"}
        rel={isEmbedded ? "noreferrer" : ""}
        suppressHydrationWarning
      >
        <div
          className={`w-full overflow-hidden rounded-xl shadow-xl transition-all hover:scale-[1.01] 
          ${
            theme === "dark"
              ? "bg-zinc-800 text-gray-500 "
              : "bg-white text-gray-400 dark:border-gray-700 dark:bg-gray-800"
          }
          ${isEmbedded === true ? "" : null}`}
        >
          <div
            className={`relative block h-72 overflow-hidden border-b bg-cover bg-center
          ${theme === "dark" ? "border-gray-700" : "border-gray-100"}
          `}
          >
            {project?.thumbnail === null ? (
              <div
                className={`flex h-full w-full items-center justify-center text-8xl font-light dark:bg-gray-700 
              `}
              >
                <PiImageThin className="h-40 w-40 fill-gray-300" />
              </div>
            ) : (
              <Image
                className="relative h-full w-full object-cover"
                src={`https://chmqmeyyaiwfybqgcdoy.supabase.co/storage/v1/object/public/projects/${project?.thumbnail}`}
                alt={project?.title}
                width={796}
                height={416}
                quality={50}
              />
            )}
          </div>
          <div className="px-5 py-4">
            <div className="relative flex items-center">
              {companyComponentVisible ? (
                <CompanyNameLogo
                  name={company?.name}
                  slug={company?.slug}
                  logo={company?.logo}
                  org_type={company?.org_type}
                  linked={false}
                />
              ) : null}
            </div>
            <div
              className={`align-left ${
                projectCardLocation === "user_profile"
                  ? "h-[130px]"
                  : "h-[130px]"
              }  text-left`}
            >
              {project?.title !== null ? (
                <h2
                  className={`text-base font-semibold line-clamp-2 ${
                    companyComponentVisible ? "" : "mt-1"
                  } ${theme === "dark" ? "text-gray-300" : "text-gray-700"}`}
                >
                  {project?.title}
                </h2>
              ) : (
                <h2
                  className={`text-base font-semibold line-clamp-2 ${
                    companyComponentVisible ? "" : "mt-1"
                  } ${theme === "dark" ? "text-gray-300" : "text-gray-400"}`}
                >
                  New Project
                </h2>
              )}

              <div
                className={`mb-3 ${
                  projectCardLocation === "user_profile" ? "h-16" : "h-16"
                }  overflow-hidden text-ellipsis text-left text-sm line-clamp-3 ${
                  placeholdersHidden ? "text-gray-500" : "text-gray-300"
                }`}
              >
                {placeholdersHidden
                  ? project?.description
                  : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex."}
              </div>
            </div>
            {cardStyle === "simple" ? (
              <ProjectCardBottomSimple
                project={project}
                theme={theme}
                placeholdersHidden={placeholdersHidden}
                projectCardLocation={projectCardLocation}
              />
            ) : (
              <ProjectCardBottomContributors
                project={project}
                theme={theme}
                placeholdersHidden={placeholdersHidden}
                projectCardLocation={projectCardLocation}
              />
            )}
          </div>
        </div>
      </Link>
    </div>
  );
}

export default ProjectItem;
